<div class="h-full min-h-0 overflow-auto">
	<div class="flex gap-2 items-center mb-4">
		<app-input-buscador
			placeholder="Buscar promoción..."
			[(valor)]="busqueda"
			class="flex-1"
			(presionaEnter)="onBuscar()"
		/>
		<app-button
			label="Nueva Promoción"
			icon="bi bi-plus"
			variant="primary"
			(onClick)="modal_crear.set(true)"
		/>
	</div>
	<div class="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-4">
		@for (promocion of promociones(); track promocion.id) {
			<app-card-promocion-impresora [promocion]="promocion" />
		} @empty {
			<div class="col-span-full text-center text-slate-500 py-10">
				No se encontraron promociones de impresora.
			</div>
		}
	</div>
</div>

<app-dialog
	header="Crear promoción de impresora"
	[modal]="true"
	[(visible)]="modal_crear"
	(onHide)="modal_crear.set(false)"
	size="md"
>
	@if (modal_crear()) {
		<app-crear-promocion-impresora (cerrar)="closeCrear($event)"></app-crear-promocion-impresora>
	}
</app-dialog>
